// extracted by mini-css-extract-plugin
module.exports = {"ButtonSpinner":"CloseTicketButton_ButtonSpinner__3-hre","ButtonLabel":"CloseTicketButton_ButtonLabel__1_y6y"};